import React from "react";
import { BloxButton } from "styled_components/Common/BloxButton";
import { Divider } from "styled_components/Common/Divider";
//import { string, func, bool, object } from 'prop-types';
import styled from "styled-components";

const ModalFooterContainer = styled.div`
  position: relative;
  width: 100%;
  height: 80px;
  min-height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) => props.theme.white};

  .message {
    position: absolute;
    bottom: 10px;
  }

  .modal-footer-buttons {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: center;
    #button-2 {
      margin-right: 24px;
    }
  }

  &.medium {
    height: 88px;
  }
  &.large {
    height: 120px;
  }
  &.landscape {
    height: 103px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    height: 88px;
    min-height: 88px;
    &.medium {
      height: 112px;
    }
    &.large {
      height: 144px;
    }
    &.landscape {
      height: 112px;
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    height: 128px;
    min-height: 128px;

    .modal-footer-buttons {
      #button-2 {
        margin-left: 32px;
      }
    }
    &.medium {
      height: 152px;
    }
    &.large {
      height: 240px;
    }
    &.landscape {
      height: 192px;
    }
  }
`;

export const ModalFooter = ({
  cypressId,
  id,
  buttonText1,
  buttonText2,
  module,
  buttonFunction1,
  buttonFunction2,
  button2Custom,
  buttonActive1,
  buttonActive2,
  size,
  message,
}) => {
  return (
    <ModalFooterContainer
      id={id}
      className={`modal-footer ${size}`}
      data-cy={cypressId}
    >
      <span className="footer-wrapper">
        <Divider />
        <div className="modal-footer-buttons">
          {buttonFunction1 && (
            <BloxButton
              id="button-1"
              text={buttonText1}
              module={module}
              enabled={buttonActive1}
              className="buttons41"
              onClick={buttonFunction1}
              cypressId="button-1"
            />
          )}
          {buttonFunction2 && (
            <BloxButton
              id="button-2"
              text={buttonText2}
              module={module}
              enabled={buttonActive2}
              className="buttons41"
              onClick={buttonFunction2}
              cypressId="button-2"
            />
          )}
          {button2Custom ? button2Custom : null}
        </div>
      </span>
      {message && <span className="message body10">{message}</span>}
    </ModalFooterContainer>
  );
};

// PopUp.propTypes = {
// 	showModal: bool,
// 	id: string,
// 	closeModal: func.isRequired,
// 	onClick: func,
// 	title: string,
// 	text: string,
// 	cypressId: string,
// 	footer: object,
// };

// PopUp.defaultProps = {
// 	showModal: false,
// 	id: '',
// 	onClick: () => {},
// 	title: 'Modal Title',
// 	text: 'Modal text',
// 	cypressId: 'pop-up-modal',
// 	footer: (
// 		<BloxButton
// 			className='buttons41'
// 			id='okay'
// 			text='OKAY'
// 			module='support'
// 			enabled={true}
// 			onClick={() => {}}
// 			cypressId='okay'
// 		/>
// 	),
// };
